<template>
  <div class="max-w-screen-2xl mx-auto px-4 md:px-10">
    <div class="bg-white rounded-xl px-8 md:px-16 py-12 font-light">
      <diamond-detail-cut-content :cut="cut" :stone-type="stoneType">
        <template #title>
          <base-headline class="!text-2xl mb-6 !normal-case !tracking-normal">
            {{ t("components.diamonds.details.cut.title") }}:
            {{ initialCutLabel }}
          </base-headline>
        </template>
      </diamond-detail-cut-content>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailCutContent from "@/components/diamonds/details/DiamondDetailCutContent.vue";

const { t } = useI18n();

const props = defineProps<{
  cut: string | string[];
  stoneType?: string;
}>();

const getNormalizedCut = (c: string) => {
  if (!c) return "ex";
  c = c.toLowerCase();
  if (c === "id" || c === "ideal") return "id";
  if (c === "ex" || c === "excellent") return "ex";
  if (c === "vg" || c === "very good") return "vg";
  if (c === "gd" || c === "good") return "gd";
  return c;
};

const cuts = [
  { key: "gd", label: "Good" },
  { key: "vg", label: "Very Good" },
  { key: "ex", label: "Excellent" },
  { key: "id", label: "Ideal" },
];

const initialCutLabel = computed(() => {
  const cutValue = Array.isArray(props.cut) ? props.cut[0] : props.cut;
  const normalized = getNormalizedCut(cutValue);
  const found = cuts.find((c) => c.key === normalized);
  return found ? found.label : cutValue;
});
</script>

<style scoped></style>
